.jw{gap:0.125rem;}